import axios from "axios";
import { router } from "../routes.js";

const instance = axios.create({
  withCredentials: true,
  baseURL: "/api",
  headers: {
    "content-type": "application/json",
  },
});
instance.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error.response) {
      const routeType = getRouteType();

      if (error.response.status === 401 && error.response.data.Err === "err.invalidSession") {
        return redirectAndReject(AUTH_ROUTES.login[routeType], error, "invalidSession");
      }
      // If there is totpEnrolment required, always redirect to the onboarding page
      if (error.response.data.Err === "err.totpEnrolmentRequired") {
        return redirectAndReject(AUTH_ROUTES.totp[routeType], error, "totpEnrolmentRequired");
      }
    }

    return Promise.reject(error);
  },
);

type RouteType = "admin" | "user" | "unknown";

const AUTH_ROUTES: Record<"totp" | "login", Record<RouteType, string | null>> = {
  totp: {
    admin: "AdminTwoFactorOnboard",
    user: "TwoFactorOnboard",
    unknown: null,
  },
  login: {
    admin: "AdminLogin",
    user: "Login",
    unknown: null,
  },
} as const;

function getRouteType(): RouteType {
  const route = router.currentRoute.value;

  if (route.meta?.requiresAdminLogin) {
    return "admin";
  } else if (route.meta?.requiresUserLogin) {
    return "user";
  }
  return "unknown";
}

async function redirectAndReject(routeName: string | null, error: any, reason: string) {
  if (routeName) {
    await router.push({ name: routeName });
    return Promise.reject({ handled: true, reason });
  }
  return Promise.reject(error);
}

export default instance;
